import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS, KEY_VALUES } from "@/constants"
import type { PermissionsResponseType } from "@/types/permissions"
import { StorageHelper } from "@/utils"
export const permissions = async () => {
  const { data } = await api.get<PermissionsResponseType>(ENDPOINTS.PERMISSIONS)
  return data
}
const usePermissions = () => {
  const accessToken = StorageHelper.getItem(KEY_VALUES.X_ACCESS_TOKEN_KEY)
  return useQuery({
    queryKey: [ENDPOINTS.PERMISSIONS],
    queryFn: permissions,
    enabled: !!accessToken,
  })
}
export default usePermissions
